/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Box, Stack, Typography } from '@mui/material';
// Wimss context
import { useWimssController, setCurrentPage, setCurrentTexts } from 'context';
import HoverImage from 'react-hover-image';

import { initTexts } from 'utils/syncState';

//import pictures
import BlueSky from 'assets/images/pictures/bluesky.png';
import SandyBeach from 'assets/images/pictures/sandy-beach.png';

import YoutubeEmbed, { FacebookEmbed } from 'assets/videos/YoutubeEmbed';
import OutdoorVd01 from 'assets/images/pictures/outdoor/outdoor_mv_01.mp4';
import OutdoorVd02 from 'assets/images/pictures/outdoor/outdoor_mv_02.mp4';
import OutdoorVd03 from 'assets/images/pictures/outdoor/outdoor_mv_03.mp4';
import PickleballVd01 from 'assets/images/pictures/pickleball/pickleball_mv_01.mp4';
import PickleballVd02 from 'assets/images/pictures/pickleball/pickleball_mv_02.mp4';
import TaichiVd01 from 'assets/images/pictures/taichi/hand-pushing.mp4';

const ActivityComponents = () => {
  const [controller, dispatch] = useWimssController();
  const {
    currentLanguage,
    isMobile,
    currentPage,
    currentTexts,
    currentTab,
    currentSlides,
  } = controller;
  const navigate = useNavigate();
  const [nav1, setNav1] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slider1, setSlider1] = useState(null);

  useEffect(() => {
    // console.log(currentSlides);
  }, [currentSlides]);
  useEffect(() => {
    setNav1(slider1);
  }, [slider1]);

  useEffect(() => {
    if (currentLanguage !== null && currentPage !== null) {
      const txts = initTexts(currentLanguage, currentPage);
      setCurrentTexts(dispatch, txts);
      // navigate(currentPage);
    }
  }, [currentLanguage, currentPage]);

  const settings = {
    dots: true,
    speed: 500,
    fade: true,
    waitForAnimate: false,
    className: 'center',
    centerMode: true,
    centerPadding: isMobile ? '0px' : '200px',
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    pauseOnHover: true,
    infinite: true,
    autoplay: true,
    onReInit: () => setCurrentSlide(slider1?.innerSlider.state.currentSlide),
    autoplaySpeed: 2000,
    lazyLoad: true,
    asNavFor: '.slider-nav',
    focusOnSelect: true,
    nextArrow: (
      <div>
        <div className='next-slick-arrow'>
          {/* <svg
            xmlns='http://www.w3.org/2000/svg'
            stroke='black'
            height='24'
            viewBox='0 -960 960 960'
            width='24'>
            <path d='m242-200 200-280-200-280h98l200 280-200 280h-98Zm238 0 200-280-200-280h98l200 280-200 280h-98Z' />
          </svg> */}
        </div>
      </div>
    ),
    prevArrow: (
      <div>
        <div className='next-slick-arrow rotate-180'>
          {/* <svg
            xmlns='http://www.w3.org/2000/svg'
            stroke='black'
            height='24'
            viewBox='0 -960 960 960'
            width='24'>
            <path d='m242-200 200-280-200-280h98l200 280-200 280h-98Zm238 0 200-280-200-280h98l200 280-200 280h-98Z' />
          </svg> */}
        </div>
      </div>
    ),
    // responsive: [
    //   {
    //     breakpoint: 1280,
    //     settings: {
    //       slidesToShow: 3,
    //       slidesToScroll: 1,
    //       infinite: true,
    //       dots: true,
    //     },
    //   },
    //   {
    //     breakpoint: 600,
    //     settings: {
    //       slidesToShow: 2,
    //       slidesToScroll: 1,
    //       initialSlide: 0,
    //     },
    //   },
    //   {
    //     breakpoint: 480,
    //     settings: {
    //       slidesToShow: 1,
    //       slidesToScroll: 1,
    //     },
    //   },
    // ],
  };

  const onButtonClicked = (path) => {
    const pg = path.substring(1);
    setCurrentPage(dispatch, pg);
    navigate(path);
  };

  return (
    <Box
      sx={{
        backgroundImage: `url(${BlueSky})`,
        backgroundRepeat: 'repeat',

        overflowY: 'auto',
        width: '100vw',
        height: '100%',

        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}>
      {currentSlides !== null && currentTexts[0].paragraphs.length > 2 && (
        <Stack
          direction='column'
          justifyContent='center'
          alignItems='center'
          spacing={2}
          sx={{ mt: isMobile ? 8 : 12 }}>
          <Typography
            variant={isMobile ? 'body' : 'h4'}
            sx={{
              fontFamily: 'Questrial',
              fontWeight: 600,
              maxWidth: isMobile ? 350 : 800,
              textAlign: 'center',
            }}>
            {currentTexts[0].paragraphs[currentTab + 1].subtitle}
          </Typography>
          <Typography variant={isMobile ? 'h6' : 'h4'}> </Typography>
          <Typography
            variant={isMobile ? 'body' : 'h5'}
            sx={{
              fontFamily: 'Montserrat',
              textAlign: 'center',
              lineHeight: '150%',
              maxWidth: isMobile ? 350 : 800,
            }}>
            {currentTexts[0].paragraphs[currentTab + 1].content}
          </Typography>
        </Stack>
      )}
      {currentTab === 0 && (
        <Box
          sx={{
            width: isMobile ? 350 : 800,

            height: 'auto',
            mt: 8,
          }}>
          <YoutubeEmbed
            embedId='JgM_l3yPdK4?si=CqtxlzgdyFdM9EIG'
            width={isMobile ? 350 : 800}
            height={isMobile ? 197 : 450}
            videoTitle='活力秘技'
          />
        </Box>
      )}
      {currentTab === 1 && (
        <Box
          sx={{
            width: isMobile ? 350 : 800,

            height: 'auto',
            mt: 8,
          }}>
          {/* <FacebookEmbed
            width={isMobile ? 350 : 800}
            height={isMobile ? 197 : 450}
            videoTitle='Intro of Pickball'
            embedId='height=315&href=https%3A%2F%2Fwww.facebook.com%2F100199211834510%2Fvideos%2F565383644898394%2F&show_text=false&width=560&t=0'
          /> */}
          <Stack direction='column' spacing={4} alignItems='center'>
            <video
              src={PickleballVd01}
              width={isMobile ? 350 : 800}
              height={isMobile ? 197 : 450}
              controls></video>

            <video
              src={PickleballVd02}
              width={isMobile ? 350 : 800}
              height={isMobile ? 197 : 450}
              controls></video>
          </Stack>
        </Box>
      )}
      {currentTab === 2 && (
        <Box
          sx={{
            width: isMobile ? 350 : 800,

            height: 'auto',
            mt: 8,
          }}>
          <Stack direction='column' spacing={4} alignItems='center'>
            <video
              src={OutdoorVd01}
              width={isMobile ? 350 : 800}
              height={isMobile ? 197 : 450}
              controls></video>

            <video
              src={OutdoorVd02}
              width={isMobile ? 350 : 540}
              height={isMobile ? 467 : 720}
              controls></video>
            <video
              src={OutdoorVd03}
              width={isMobile ? 350 : 540}
              height={isMobile ? 467 : 720}
              controls></video>
          </Stack>
        </Box>
      )}
      {currentTab === 3 && (
        <Box
          sx={{
            width: isMobile ? 350 : 800,

            height: 'auto',
            mt: 8,
          }}>
          <Stack direction='column' spacing={4} alignItems='center'>
            <YoutubeEmbed
              embedId='qE6sSWBltHA'
              width={isMobile ? 350 : 800}
              height={isMobile ? 197 : 450}
              videoTitle='Wu-Style Tai Chi 108 Traditional Standard Form'
            />
            <YoutubeEmbed
              embedId='e4VIw41R-PU'
              width={isMobile ? 350 : 800}
              height={isMobile ? 197 : 450}
              videoTitle='吳阿敏背向示範楊式24式太極拳'
            />
            <YoutubeEmbed
              embedId='niFUaaCwYag'
              width={isMobile ? 350 : 800}
              height={isMobile ? 197 : 450}
              videoTitle='吳阿敏48式太極拳'
            />
            <YoutubeEmbed
              embedId='vMPyFG5E888'
              width={isMobile ? 350 : 800}
              height={isMobile ? 197 : 450}
              videoTitle='吴阿敏~48式太极拳正面 背面合一示范'
            />
            <YoutubeEmbed
              embedId='an5qNCspzUw'
              width={isMobile ? 350 : 800}
              height={isMobile ? 197 : 450}
              videoTitle='24 forms Yang Style Taichi Chuan by Master Jiamin Gao'
            />

            <video
              src={TaichiVd01}
              width={isMobile ? 350 : 540}
              height={isMobile ? 467 : 720}
              controls></video>
          </Stack>
        </Box>
      )}

      {currentSlides !== null && currentTab !== 4 && (
        <Box
          sx={{
            width: isMobile ? 350 : 1200,

            height: 'auto',
            mt: 8,
          }}>
          <Slider
            {...settings}
            asNavFor={nav1}
            ref={(slider) => setSlider1(slider)}>
            {currentSlides.map((item) => (
              <div key={item.id}>
                <div>{item.component}</div>
              </div>
            ))}
          </Slider>
          {!isMobile && (
            <div className='thumb-wrapper'>
              {currentSlides.map((item, idx) => (
                <div
                  key={item.id}
                  className={currentSlide === idx ? 'active' : null}
                  onClick={() => {
                    slider1?.slickGoTo(idx);
                  }}>
                  {item.component}
                </div>
              ))}
            </div>
          )}
        </Box>
      )}
      {currentTexts !== null && (
        <Box
          sx={{
            backgroundImage: `url(${SandyBeach})`,

            overflowY: 'auto',
            width: '100vw',
            height: 300,

            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}>
          {currentTab !== 4 && (<HoverImage
            src={currentTexts[0].paragraphs[currentTab + 1].button}
            hoverSrc={currentTexts[0].paragraphs[currentTab + 1].btn_hover}
            onClick={() =>
              onButtonClicked(currentTexts[0].paragraphs[currentTab + 1].action)
            }
            style={{ height: '128px' }}
          />)}
        </Box>
      )}
    </Box>
  );
};

export default ActivityComponents;
